import React, { useCallback, useContext } from "react";
import { Route, Routes } from "react-router-dom";

import { InnerFormContext } from "../../controls/innerFormContext";
import { useToFormOnEmpty } from "../../helpers";

const ConfirmationWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const formContext = useContext(InnerFormContext);
  const handleSubmit = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if ((e.target as HTMLDivElement).getAttribute("type") === "submit") {
        formContext?.submitData();
      }
    },
    [formContext]
  );
  useToFormOnEmpty(formContext?.formData);
  return <div onClick={handleSubmit}>{children}</div>;
};

export const ConfirmationView: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Routes>
      <Route path="confirm" element={<ConfirmationWrapper>{children}</ConfirmationWrapper>} />
    </Routes>
  );
};
